import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useDocumentTitle } from "../hooks/useDocumentTitle.js";
import { getSessionToken } from "../hooks/useSession.js";
import { requestSurelcLogin, submitSurelcForm } from "../lib/surelcSso.js";
import { PageBody } from "./ui/PageHeader.js";
import { LoadingStatus } from "./ui/index.js";

export function SurelcSsoPage() {
  useDocumentTitle("SureLC");
  const [params] = useSearchParams();
  const [error, setError] = useState<string | null>(null);
  const samlRequest = params.get("SAMLRequest") ?? "";
  const relayState = params.get("RelayState") ?? "";
  const binding = params.get("binding") === "post" ? "post" : "redirect";

  useEffect(() => {
    const token = getSessionToken();
    if (!token) {
      setError("Sign in again, then retry the SureLC link.");
      return;
    }
    if (!samlRequest) {
      setError("This SureLC sign-in link did not include a login request. Open SureLC from Contracts instead.");
      return;
    }
    let cancelled = false;
    void requestSurelcLogin(token, { samlRequest, relayState, binding })
      .then((login) => {
        if (cancelled) return;
        submitSurelcForm(window, login);
      })
      .catch((launchError: unknown) => {
        if (!cancelled) {
          setError(launchError instanceof Error ? launchError.message : "Unable to open SureLC");
        }
      });
    return () => {
      cancelled = true;
    };
  }, [binding, relayState, samlRequest]);

  return (
    <PageBody constrained>
      {error ? (
        <p className="text-sm text-status-rejected-text" role="alert">
          {error}
        </p>
      ) : (
        <p className="text-sm text-content-secondary" role="status" aria-busy="true">
          <LoadingStatus label="Signing you in to SureLC" />
          Signing you in to SureLC…
        </p>
      )}
    </PageBody>
  );
}
